import styled from 'styled-components';
import { BodyBoldL, BodyRegularL, BodyRegularS } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';
import Icon from '@/assets/icons/communiq-logo-text-blue.svg?react';
import background from '@/assets/images/communiq-bubbles-bg.svg?react';

export const AccessDeniedCont = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  flex-flow: column nowrap;
  justify-content: center;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]} url(${background}) no-repeat center/cover;
  `}
`;

export const LogoIcon = styled(Icon)`
  width: 200px;
  height: 200px;
`;

export const ContentCont = styled.div`
  display: flex;
  max-width: 1160px;
  width: 100%;
  margin: 0 auto;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`;

export const AccessDeniedStatus = styled(BodyRegularL)`
  text-align: center;

  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.mikro};
  `};
`;

export const AccessDeniedHeading = styled(BodyBoldL)`
  text-align: center;

  ${({ theme }: IThemeProvider) => `
  margin: 0 0 ${theme.layout.spacing.mikro};
  color: ${theme.colors.neutral.primary[100]}
  `}
`;

export const AccessDeniedText = styled(BodyRegularS)`
  text-align: center;
`;
